import React from 'react';
import './DayItem.scss';
import {DAY_NUMBER} from "../../../../tools/formatter";
import {connect} from "react-redux";
import Counters from "../../Counters/Counters";
import {Card, CardActionArea, CardActions, CardContent, CardMedia} from "@mui/material";
import Typography from "@mui/material/Typography";
import config from "../../../../api/config";
import {cardMediaStyles} from "../../../../styles/styles";

function DayItem(props) {
	const {item, itemDate} = props;
	return <Card className={'DayItem DiaryItem'} sx={{ maxWidth: 800 }}>
		<CardActionArea>
			<CardContent>
				<Typography className={props.currentNavigationDay === itemDate.date().toString() ? " active" : ""} gutterBottom variant="h5" component="div">
					{itemDate.format(DAY_NUMBER)}
				</Typography>
			</CardContent>
			<CardMedia
				component="img"
				image={props.label != null ? (props.label !== false ? config.thumbnailLambdaUrl + '?key=/' + props.label.userimage + (props.label.transform ? '&transform=' + props.label.transform : '') : "/noimage.jpg") : '/loading.gif'}
				alt={props.label?.userimage || 'No image'}
				sx={cardMediaStyles}
			/>
			<CardActions sx={{ pt: 2, pr: 2.5, pb: 1, pl: 1, minHeight: 64 }}>
				<Counters item={item} parentComponent={'DayItem'} />
			</CardActions>
		</CardActionArea>
	</Card>
}

const mapStateToProps = state => {
	return {
		currentNavigationDay: state.eventsData.currentNavigationDay
	};
};

export default connect(mapStateToProps)(DayItem);
